<div class="cart-details__content">
    <div class="cart-details" *ngIf="!showNoResults">

        <div class="col-lg-12" *ngIf="!showIframeURL">
            <div class="cart-details__header">
                <div *ngIf="!gs.isbookingCompleted">{{'MyActivitiesCart' | translate}}</div>
                <div *ngIf="gs.isbookingCompleted">{{'MyBookings' | translate}}</div>
                <div class="cart-details__amount-container" *ngIf="!gs.isbookingCompleted">

                    <div class="cart-details__time-container" *ngIf="gs.showTimer">
                        <div class="focused-sub-header  cart-details__time-mins"
                            [ngStyle]="gs.minutes === 0 && gs.seconds < 60 ?  {'color':'#B00020'} : {'color':'#635D7B'}">
                            <span class="cart-details__timer-number">{{gs.minutes}}</span>
                            <span class="error-message">{{'mins' | translate}}</span> <span
                                class="cart-details__timer-number">{{gs.seconds}}</span> <span
                                class="error-message">{{'secs'
                                |
                                translate}}</span>
                        </div>
                        <div class="cart-details__time-left-text">{{'leftForBooking' | translate}}</div>
                    </div>
                    <div class="cart-details__time-container">
                        <span>{{'TotalPayable' | translate}}</span> <span>{{' '}}</span>{{':'}}<span>{{' '}}</span>
                        <span>{{OperationCurrency}}{{ TotalCartValue | currencyDecimalFormatter}}</span>
                    </div>
                </div>
            </div>

            <div class="cart-details__container">
                <div class="cart-details__container--card" *ngFor="let party of CartList;let i=index">
                    <mat-card class="cart-details__container__card-details"
                        *ngIf="!gs.isbookingCompleted || party.SlotLockResult">
                        <div class="cart-details__img-container">
                            <section class="class-info__image" *ngIf="party.bannerImage"
                                [style.background-image]="'url(data:image/png;base64,'+ party.bannerImage +')'">
                            </section>
                            <section class="class-info__image" *ngIf="!party.bannerImage"
                                [style.background-image]="'url(assets/images/defaultImage.png)'">
                            </section>
                        </div>
                        <mat-card class="cart-details__container__card">
                            <div class="cart-details__container__card-container"
                                [ngStyle]="!party.SlotLockResult ? {'opacity' : '0.4'} : {'opacity' : '1'} ">
                                <div class="cart-details__container__card--lessonName text-overflow">
                                    {{party.ActivityName ? party.ActivityName : party.SelectedActivity?.LessonName}}
                                </div>
                                <div class="cart-details__container__card--StaffName text-overflow"
                                    *ngIf="(party.StaffsList && party.StaffsList.length)">{{'By' | translate}}
                                    <span>{{party.StaffsList[0]}}</span><span title="{{party.Staffs}}"
                                        *ngIf="party.StaffsList.length > 1">+{{party.StaffsList.length - 1}}</span>
                                </div>
                                <div class="cart-details__container__card--StaffName text-overflow"
                                    *ngIf="!(party.StaffsList && party.StaffsList.length) && party.SpecialMealId && party.SelectedActivity?.Staffs ">{{'By'|translate}}
                                    <span>{{party.SelectedActivity.Staffs}}</span>
                                </div>
                                <div class="cart-details__container__card--LocName" *ngIf="party.TableList && party.TableList.length">

                                    <mat-icon class="location_on" aria-hidden="false" aria-label="location">location_on
                                    </mat-icon>
                                    <span class="cart-details__container__itemName"
                                        *ngIf="party.TableList && party.TableList.length">
                                        {{party.TableList[0]}}
                                    </span>
                                    <span title="{{party.TableNames}}"
                                        *ngIf="party.TableList && party.TableList.length > 1">+{{party.TableList.length
                                        - 1}}
                                    </span>
                                    {{' '}}|{{' '}}<span
                                        class="cart-details__container__itemName">{{party.Size}}</span>{{' '}}
                                    <mat-icon class="person" aria-hidden="false" aria-label="location">person</mat-icon>
                                </div>
                                <div class="cart-details__container__card--LocName" *ngIf="!(party.TableList && party.TableList.length) && party.SelectedActivity?.LocationName">

                                    <mat-icon class="location_on" aria-hidden="false" aria-label="location">location_on
                                    </mat-icon>
                                    <span class="cart-details__container__itemName"
                                        *ngIf="!(party.TableList && party.TableList.length) && party.SelectedActivity?.LocationName">
                                        {{party.SelectedActivity.LocationName}}
                                    </span>
                                   
                                    {{' '}}|{{' '}}<span
                                        class="cart-details__container__itemName">{{party.Size}}</span>{{' '}}
                                    <mat-icon class="person" aria-hidden="false" aria-label="location">person</mat-icon>
                                </div>
                            </div>
                        </mat-card>
                        <div class="cart-details__container__empty-div cart-details___margin"></div>
                        <div class="cart-details__container__wrapper"
                            [ngStyle]="!party.SlotLockResult ? {'opacity' : '0.4'} : {'opacity' : '1'} ">
                            <div class="cart-details__container__date-container cart-details___margin" *ngIf="party.Id">
                                {{party.StartDate | localizeDate:'DD MMM YYYY'}} {{' To '}} {{party.EndDate | localizeDate: 'DD MMM
                                YYYY'}}
                            </div>
                            <div class="cart-details__container__date-container cart-details___margin"
                                *ngIf="!party.Id">
                                {{'On' | translate}} {{' '}} {{party.StartDate | localizeDate:'DD MMM YYYY'}}
                            </div>
                            <div class="cart-details__container__charge-container">
                                <div class="cart-details__container__charge">
                                    <div class="cart-details__container__charge--row">
                                        <span class="text-overflow">{{'SessionCharge' | translate}}</span>
                                        <span class="cart-details__container__charge--value"
                                            *ngIf="party.RatePlan?.TotalRatePlan">{{OperationCurrency}}{{'
                                            '}}{{party.RatePlan?.TotalRatePlan | currencyDecimalFormatter}}</span>
                                        <span class="cart-details__container__charge--value"
                                            *ngIf="!party.RatePlan?.TotalRatePlan">{{OperationCurrency}}{{'
                                            '}}{{ 0 | currencyDecimalFormatter}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="cart-details__container__charge-container">
                                <div class="cart-details__container__charge--row"
                                    *ngIf="!party.RatePlan?.TotalDepositAmount">
                                    <span class="cart-details__container__charge--value">{{'total'| translate}}</span>
                                    <span class="cart-details__container__charge--value"
                                        *ngIf="party.RatePlan?.TotalRatePlan">{{OperationCurrency}}{{'
                                        '}}{{party.RatePlan?.TotalRatePlan | currencyDecimalFormatter}}</span>
                                    <span class="cart-details__container__charge--value"
                                        *ngIf="!party.RatePlan?.TotalRatePlan">{{OperationCurrency}}{{'
                                        '}}{{ 0 | currencyDecimalFormatter}}</span>
                                </div>
                                <div class="cart-details__container__charge--row"
                                    *ngIf="party.RatePlan?.TotalDepositAmount">
                                    <span class="cart-details__container__charge--value">{{'Deposit'| translate}}</span>
                                    <span class="cart-details__container__charge--value">{{OperationCurrency}}{{'
                                        '}}{{party.RatePlan?.TotalDepositAmount| currencyDecimalFormatter}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="cart-details__container__actions">
                            <div class="cart-details__container__actions--button"
                                *ngIf="party.SlotLockResult && !gs.isbookingCompleted" (click)="editItem(party, i)">
                                <mat-icon class="mat-icon cursor-pointer" [matTooltip]="'Edit' | translate"
                                    matTooltipPosition="above" aria-hidden="false" aria-label="Edit">
                                    edit</mat-icon>
                                <span class="cursor-pointer">{{'edit' | translate}}</span>
                            </div>
                            <span>{{' '}}</span>
                            <div class="cart-details__container__actions--button" (click)="removeItem(party, i)"
                                *ngIf="!gs.isbookingCompleted">
                                <mat-icon class="mat-icon cursor-pointer" [matTooltip]="'Delete' | translate"
                                    matTooltipPosition="above" aria-hidden="false" aria-label="Delete">delete</mat-icon>
                                <span class="cursor-pointer">{{'remove' | translate}}</span>
                            </div>
                            <div class="cart-details__container__actions--button cart-details__container__actions--View-btn"
                                *ngIf="gs.isbookingCompleted" (click)="viewPartySummary(party)">
                                {{'ViewSummary' | translate}}
                            </div>
                        </div>
                    </mat-card>
                </div>
            </div>
        </div>

        <div class="col-lg-9 Iframe-container" [ngClass]="showIframeLoader ? 'Iframe-loader' :''" *ngIf="showIframeURL">
            <iframe title="" class="Iframe-container__margin" width="560px" height="560px" [src]="IframeURL"></iframe>
        </div>
        <div class="col-lg-3 payment-container" *ngIf="showIframeURL">
            <div class="cart-details__time-container" *ngIf="gs.showTimer">
                <div class="cart-details__header">
                <div class="focused-sub-header  cart-details__time-mins"
                    [ngStyle]="gs.minutes === 0 && gs.seconds < 60 ?  {'color':'#B00020'} : {'color':'#635D7B'}">
                    <span class="cart-details__timer-number">{{gs.minutes}}</span>
                    <span class="error-message">{{'mins' | translate}}</span> <span
                        class="cart-details__timer-number">{{gs.seconds}}</span> <span
                        class="error-message">{{'secs'
                        |
                        translate}}</span>
                </div>
                <div class="cart-details__time-left-text pt-3">{{'leftForBooking' | translate}}</div>
            </div>
            </div>
            <div class="payment-container__header">
                {{'PaymentSummary' | translate}}
            </div>
            <div class="payment-container__charge-container">
                <div class="cart-details__container__charge">
                    <div class="cart-details__container__charge--row">
                        <span>{{'SubTotal' | translate}}</span>
                        <span class="cart-details__container__charge--value">{{OperationCurrency}}{{'
                            '}}{{TotalCartValue | currencyDecimalFormatter}}</span>
                    </div>
                    <!-- <div class="cart-details__container__charge--row">
                        <span>{{'MembershipDiscount' | translate}}</span>
                        <span class="cart-details__container__charge--value">{{OperationCurrency}}{{'
                            '}}{{TotalMembershipDiscount | currencyDecimalFormatter}}</span>
                    </div>
                    <div class="cart-details__container__charge--row">
                        <span>{{'DepositAmount' | translate}}</span>
                        <span class="cart-details__container__charge--value">{{OperationCurrency}}{{'
                            '}}{{TotalDepositAmount | currencyDecimalFormatter}}</span>
                    </div> -->
                </div>
            </div>
            <div class="cart-details__container__charge-container">
                <div class="cart-details__container__charge--row">
                    <span class="cart-details__container__charge--value">{{'TotalPayable'| translate}}</span>
                    <span class="cart-details__container__charge--value">{{OperationCurrency}}{{'
                        '}}{{TotalCartPayment | currencyDecimalFormatter}}</span>
                </div>
            </div>

            <div class="payment-container__action-button">
                <app-button [buttontype]="backToSummaryBtn" class="payment-container__button"
                    (valueChange)="backtosummaryBooking()">
                </app-button>
                <app-button [buttontype]="cancelBookingBtn" class="payment-container__button"
                    (valueChange)="backtosummaryBooking()">
                </app-button>
            </div>
        </div>
    </div>

    <div class="payment-container__payment-action-btn" *ngIf="!showIframeURL">
        <app-button [buttontype]="proceedBtn" class="payment-container__button"
            *ngIf="!gs.isbookingCompleted && !showNoResults" (valueChange)="proceedBooking()">
        </app-button>
        <app-button [buttontype]="cancelBtn" class="payment-container__button"
            *ngIf="!gs.isbookingCompleted && !showNoResults" (valueChange)="cancelBooking()">
        </app-button>
        <app-button [buttontype]="continueBtn" class="payment-container__button" (valueChange)="continueBooking()">
        </app-button>
    </div>

    <div *ngIf="showNoResults">
        <div class="cart-details__empty-cart"> {{'YourCartisEmpty' | translate}}
        </div>
    </div>
</div>